module.exports = __webpack_public_path__ + "img/post_paid.41f36cb3.png";